import { lazy, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useFlagsStatus } from '@unleash/proxy-client-react';
import { AnimatePresence } from 'framer-motion';

import Loader from 'shared/Loader';

import { ZoomCallProvider } from 'contexts/zoomCallContext/zoomCallContext';
import { lazyRetry } from 'utils/lazy';

import {
  getMainLayoutAppointmentRoutes,
  getProtectedAppointmentRoutes,
  getTopLevelAppointmentRoutes
} from './appointmentRoutes';
import { getAuthRoutes } from './authRoutes';
import { getMainLayoutRoutes } from './mainRoutes';
import { getMainLayoutProgramRoutes, getProtectedProgramRoutes } from './programRoutes';
import Router from './Router';
import { RouteScrollTop } from './ScrollToTop';
import { getSignupRoutes } from './signupRoutes';

const Main = lazy(() => lazyRetry(() => import('layouts/Main')));

const AppRouter = () => {
  const { flagsReady } = useFlagsStatus();
  const location = useLocation();

  if (!flagsReady) {
    return <Loader isVisible />;
  }

  return (
    <>
      <RouteScrollTop />
      <Suspense fallback={<Loader isVisible />}>
        <AnimatePresence mode="wait">
          <Routes>
            {getTopLevelAppointmentRoutes()}
            {getSignupRoutes()}
            <Route element={<Router />}>
              <Route
                element={
                  <ZoomCallProvider>
                    <AnimatePresence mode="wait">
                      <Routes key={location.pathname} location={location}>
                        <Route element={<Main />}>
                          {getMainLayoutAppointmentRoutes()}
                          {getMainLayoutRoutes()}
                          {getMainLayoutProgramRoutes()}
                        </Route>
                        {getProtectedAppointmentRoutes()}
                        {getProtectedProgramRoutes()}
                      </Routes>
                    </AnimatePresence>
                  </ZoomCallProvider>
                }
                path="/*"
              />
              {getAuthRoutes()}
            </Route>
          </Routes>
        </AnimatePresence>
      </Suspense>
    </>
  );
};

export default AppRouter;
